// removed by extract-text-webpack-plugin
module.exports = {"container":"H7R_APlF84VJuWEUxijAL","noResults":"HcqRc-K6ZYz7j7WQFNDS"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4b694854","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/shared/SearchContacts/SearchMode/SearchMode.less
// module id = ym5d
// module chunks = 1